var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AlertModal',_vm._g(_vm._b({staticClass:"alert-socials-modal"},'AlertModal',_vm.$attrs,false),_vm.$listeners),[_vm._t("default"),_c('ModalSocials',{staticClass:"mt-4"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }